import React, { useEffect } from 'react';
import { MultiStepSignup } from 'features/authentication/signup/components/multi-step-signup/multi-step-signup';
import { useSplunkCallback } from 'hooks/use-splunk-callback/use-splunk-callback';
import { signupBaseSplunkData } from 'features/authentication/utils/constants';
import { redirectToDashboard } from 'store/auth/utils/utils';
import { goToAdminExplore } from 'router/go-to';
import { getLoginCookie } from 'utils/cookies/utils';
import { useRouteParam } from 'hooks/use-query/use-query';
import { AuthPageWrapper } from 'features/authentication/auth-page-wrapper/auth-page-wrapper';
import { WebviewLogin } from 'features/authentication/components/webview-login/webview-login';

export const SignupPage = () => {
    const sendEvent = useSplunkCallback(signupBaseSplunkData);
    const nextUrlQueryParam = useRouteParam('next_url');
    const shouldGoToFullSignUpForm = useRouteParam('google_auth');

    useEffect(() => {
        sendEvent({ action: 'signup-page-viewed' });
    }, [sendEvent]);

    useEffect(() => {
        const isLoggedIn = getLoginCookie();
        if (isLoggedIn && shouldGoToFullSignUpForm) return;
        if (isLoggedIn) {
            nextUrlQueryParam ? redirectToDashboard(nextUrlQueryParam) : goToAdminExplore();
        }
    }, [nextUrlQueryParam, shouldGoToFullSignUpForm]);

    if (window.placerMobile) return <WebviewLogin />;

    return (
        <AuthPageWrapper>
            <MultiStepSignup />
        </AuthPageWrapper>
    );
};

export default SignupPage;
